<template>
  <div class="container mt-4">

    <div class="card shadow p-4 border-0" style="border-radius: 16px;">
      <h4 class="mb-4" style="color: #b03a45;">
        <i class="material-icons-round me-2" style="color:#b03a45;">badge</i>
        {{ $t("employeeProfessionalInfo.title") }}
      </h4>

      <!-- LOADING -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border text-danger"></div>
        <div class="mt-2 text-muted">
          {{ $t("employeeProfessionalInfo.loading") }}
        </div>
      </div>

      <!-- NO DATA -->
      <div v-else-if="!info" class="text-center text-muted my-4">
        {{ $t("employeeProfessionalInfo.noData") }}
      </div>

      <!-- DATA -->
      <div v-else>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.cin") }}:
          </strong>
          <span class="value">{{ info.cin }}</span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.cnss") }}:
          </strong>
          <span class="value">{{ info.cnss_number }}</span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.company") }}:
          </strong>
          <span class="value">{{ info.company?.english_name }}</span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.project") }}:
          </strong>
          <span class="value">{{ info.project?.name }}</span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.position") }}:
          </strong>
          <span class="value">{{ info.position?.english_name }}</span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.manager") }}:
          </strong>
          <span class="value">
            {{ info.manager?.firstname }} {{ info.manager?.lastname }}
          </span>
        </div>

        <div class="info-box p-3 mb-3">
          <strong class="label">
            {{ $t("employeeProfessionalInfo.fields.supervisor") }}:
          </strong>
          <span class="value">
            {{ info.supervisor?.firstname }} {{ info.supervisor?.lastname }}
          </span>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import axios from "@/api";

export default {
  name: "EmployeeProfessionalInfo",

  data() {
    return {
      info: null,
      loading: true,
    };
  },

  async mounted() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await axios.get(
        `/employee/professional-information/${user.id}`
      );

      this.info = response.data.data;

    } catch (err) {
      console.error("ERROR =", err);
      this.info = null;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.info-box {
  background: #f8f9fa;
  border-left: 4px solid #b03a45;
  border-radius: 8px;
}

.label {
  color: #b03a45;
  font-size: 16px;
}

.value {
  font-size: 16px;
}
</style>
